import { listReadableForAccount } from './common'
import { asRecordId, getRootCollection } from './queries'

export const listClientInvitations = () =>
  getRootCollection('clientInvitations')

const whereFromAccount = (account) => (query) =>
  query.where('fromAccountId', '==', asRecordId(account))

const whereToAccount = (account) => (query) =>
  query.where('toAccountId', '==', asRecordId(account))

export const listSentClientInvitationsForAccount = (account) =>
  listReadableForAccount(
    listClientInvitations,
    whereFromAccount(account)
  )(account)

export const listReceivedClientInvitationsForAccount = (account) =>
  listReadableForAccount(
    listClientInvitations,
    whereToAccount(account)
  )(account)
